import config from 'config';
import Auth0 from './Auth0';
import Keycloak from './Keycloak';
import TestingMock from './TestingMock';
import { Auth, AuthProvider } from './Auth.types';

const setAuthAdaptor = (provider: AuthProvider): Auth => {
  if (provider === AuthProvider.Keycloak) {
    return Keycloak;
  }
  return Auth0;
};

const getAuthProvider = (): Auth => {
  if (config.environment === 'testing') {
    return TestingMock;
  }
  return setAuthAdaptor(config.authProvider as AuthProvider);
};

export default getAuthProvider();
